import { axiosInstance } from './../config';
import { VerificationDataBody } from '../../pages/reports/verification/types';

export const verification = {
	getVerificationReport(verificationData: VerificationDataBody) {
		return axiosInstance.post('/reporting/verification_reports', verificationData).then((res) => res.data);
	},
};
